export default __webpack_public_path__ + "static/media/805.0d9bda55.png";